export default "__VITE_ASSET__DCd7mXAq__"